// src/hooks/useExpertLogout.ts
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

// Import Actions & API
import { clearRegistrationData } from '../../store/slices/expertSlice';
import { logoutExpert } from '../../api/logout.api';

export const useExpertLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = async () => {
    try {
      // 1. Tell Backend to clear the Secure Cookie
      // We await this, but even if it fails (e.g. network error),
      // we MUST continue to clear the frontend session.
      await logoutExpert();
    } catch (error) {
      console.warn("Backend logout warning:", error);
    } finally {
      // 2. Clear ALL Local Storage (Frontend cleanup)
      localStorage.removeItem('expertCode');
      localStorage.removeItem('expertName');
      
      // 🧹 Cleanup old/stale keys if they exist
      localStorage.removeItem('expertId'); 
      localStorage.removeItem('token');
      localStorage.removeItem('accessToken');

      // 3. Clear Redux Store
      dispatch(clearRegistrationData());

      // 4. Feedback & Redirect
      toast.success('Logged out successfully');
      navigate('/expert-login', { replace: true });
    }
  };

  return { logout };
};